module.exports = __webpack_public_path__ + "img/monaco.326c8095.svg";